module.exports = __webpack_public_path__ + "static/media/empresa-02.f90c7b79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresa-02.jpg
// module id = 86
// module chunks = 0